const UK_REGISTRATION_PATTERN = /^(?:[A-Z]{2}\d{2}\s?[A-Z]{3}|[A-Z]\d{1,3}\s?[A-Z]{3}|[A-Z]{3}\s?\d{1,3}[A-Z]|[A-Z]{1,3}\s?\d{1,4})$/i;

const ukRegistrationValidation = {
  required: "Required",
  validate: (value) =>
    UK_REGISTRATION_PATTERN.test(String(value || "").trim()) ||
    "Enter a valid UK vehicle registration",
  setValueAs: (value) => String(value || "").toUpperCase(),
};

export default ukRegistrationValidation;
